module.exports = __webpack_public_path__ + "static/media/website_cn.e3b1abbd.png";